import { type ReactElement } from 'react'
import { Controller, type FieldValues } from 'react-hook-form'

import Autocomplete from '@mui/material/Autocomplete'
import Chip from '@mui/material/Chip'
import FormControl from '@mui/material/FormControl'
import FormHelperText from '@mui/material/FormHelperText'
import TextField from '@mui/material/TextField'

import { getFieldErrorMessages } from 'global/helpers/form'
import type { KNFormTagsProps } from './types'

const KNFormTags = <T extends FieldValues>({
                                             name,
                                             control,
                                             rules,
                                             label,
                                             size,
                                             sx,
                                             disabled,
                                           }: KNFormTagsProps<T>): ReactElement => (
  <Controller
    name={name}
    control={control}
    rules={rules}
    render={({ field: { onChange, value, name, ref }, fieldState: { invalid, error }, formState }): ReactElement => (
      <FormControl data-test={name} fullWidth sx={sx} error={invalid}>
        <Autocomplete
          size={size}
          disabled={formState.isSubmitting || disabled}
          renderValue={(tagValue, getTagProps): ReactElement[] =>
            tagValue.map((option, index) => (
              // eslint-disable-next-line react/jsx-key
              <Chip {...getTagProps({ index })} variant="outlined" size="small" label={option} />
            ))
          }
          renderInput={(params): ReactElement => <TextField {...params} label={label} error={invalid} />}
          value={value}
          onChange={(event, value, reason): void => {
            onChange(value)
          }}
          options={[]}
          multiple
          freeSolo
          disableClearable
          // isOptionEqualToValue={(option, value): boolean => option.value === value.value}
        />
        {error?.message && <FormHelperText>{getFieldErrorMessages(error)}</FormHelperText>}
      </FormControl>
    )}
  />
)

export default KNFormTags
